var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('v-sheet',{staticClass:"d-flex justify-center align-center",attrs:{"color":"#f0f0f0","height":"100%","width":"100%","tile":""}},[_c('ImageChooser',{attrs:{"size":_vm.size,"title":_vm.title,"categories":_vm.categories,"imageSizes":_vm.imageSizes},on:{"onSave":_vm.onCropperEnd}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }